import * as types from "./types";

export const setProcessesStatus = (data) => (dispatch) => {
  return dispatch({
    type: types.ALL_PROCESSES,
    data,
  });
};